'use client';

import useAudioPlayerStore from '@/client/stores/useAudioPlayerStore';
import { ReleaseTrackInfo } from '@/common/model';
import { Button } from '@/components/ui/button';
import { cachedReadTrackById } from '@/server/actions/track-actions';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';

interface Props {
  className?: ClassValue;
  track: ReleaseTrackInfo;
}

export function ReleaseCardTrackItem({ className, track }: Props) {
  const { setTrack } = useAudioPlayerStore();

  const onClick = async () => {
    setTrack(await cachedReadTrackById(track.id));
  };

  return (
    <li key={track.id}>
      <Button className={cn('h-auto hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black', className)} onClick={onClick}>
        <span className={'inline-block text-wrap'}>{track.title}</span>
      </Button>
    </li>
  );
}
